import {IntermediatePart} from "../../intermediatePart";
import {LayoutType} from "../../constants";
import {Shower} from "../../parts/shower";

export default class LeftWall extends IntermediatePart {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'left_wall';
    this.partName = 'Left Wall';
    this.translateId = "visualizer.bathroom.walls.left_wall";
    this.activeFeatureBeforeAllWalls = null;
    this.allWallsApplied = true;
    this.isStoneFeature = true;
    this.partsLayouts = [LayoutType.Layout4];
  }

  load(dbFeature) {
    const partsRoomLayouts = this.partsLayouts.map(pl => "Layout"+pl);
    const isPartFeature = !dbFeature.metaData["RoomLayout"] || partsRoomLayouts.some(layoutType => {
      return dbFeature.metaData["RoomLayout"].includes(layoutType)
    });
    if (isPartFeature) {
      const part1 = dbFeature.metaData["LayerType"] && dbFeature.metaData["MirrorSize"];
      const partNumber = part1 ? 1 : 2;
      return super.load_(dbFeature, new LeftWall(false, partNumber),
        true, partNumber === 1 ? 'features' : 'featuresParts');
    }
    return super.load_(dbFeature, new LeftWall(false, 1, true, "features"));
  }

  availableFeatures(features) {
    return features.filter(feature => feature.partNumber === 1)
  }

  setLayers(layout) {
    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions()))) {
      this.checkIfFeaturePartIsMatching();
      super.setLayers(layout);
    } else {
      this.setDefault();
      super.setLayers(layout);
    }
  }

  setActiveFeatureParts(fromFeature = this.activeFeature, activeFeatureConditions = []) {
    return this.getActiveFeaturePartsAccordingToActiveFeature(fromFeature, activeFeatureConditions);
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions(); // roomLayout
    const shower = this.getParent().layout.parts[Shower.id];
    if (shower && shower.showerSize()) {
      conditions.push({
        propName: "ShowerSize",
        propValue: shower.showerSize()
      })
    }
    return conditions
  }

  setZIndex(zIndexes) {
    const layout = this.getParent().layout;
    const isPartsLayout = this.partsLayouts.includes(layout.type);
    if (zIndexes) {
      const zIndex = isPartsLayout ? zIndexes.Walls.LeftWall : zIndexes.Background.LeftWall;
      const zIndex2 = zIndexes.Background.LeftWall;
      if (this.activeFeature) {
        this.activeFeature.layer.zIndex = zIndex;
      }
      if (this.activeFeatureParts && this.activeFeatureParts.length) {
        this.activeFeatureParts.forEach((activeFeaturePart) => {
          if (activeFeaturePart && activeFeaturePart.layer) {
            activeFeaturePart.layer.zIndex = zIndex2;
          }
        })
      }
    }
  }
}
